import { defineComponent as s, resolveComponent as o, openBlock as l, createBlock as i } from "vue";
import { TextInputSelectComp as u } from "./TextInputSelectComp.js";
import { _ as r } from "./_plugin-vue_export-helper.dad06003.js";
const d = s({
  events: {
    "update:modelValue": {
      type: Object
    }
  },
  components: {
    TextInputSelectComp: u
  },
  props: {
    id: {
      type: String,
      required: !0
    },
    modelValue: {
      type: Object,
      default: null
    },
    filterFunction: {
      type: Function,
      default: (e) => e
    },
    width: String,
    /**
     * Used for disabling error or info messages from being seen or validation from running
     */
    disableMessages: Boolean,
    /**
     * Used for determining when to run the validation rules on input
     */
    validateOn: {
      type: String,
      default: "blur"
    }
  },
  data() {
    return {
      languages: []
    };
  },
  computed: {
    selectedLanguage: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  },
  async created() {
    this.languages = (await this.getLanguages()).filter(this.filterFunction).map((e) => ({
      text: e.text,
      value: e.value
    }));
  },
  methods: {
    async getLanguages() {
      try {
        return await (await fetch("/i18n/languages.json", {
          headers: { "Content-Type": "application/json" }
        })).json();
      } catch {
        return [];
      }
    },
    validate() {
      return this.$refs.textInputSelectComp.validate();
    }
  }
});
function p(e, t, g, c, m, f) {
  const a = o("text-input-select-comp");
  return l(), i(a, {
    id: e.id,
    ref: "textInputSelectComp",
    modelValue: e.selectedLanguage,
    "onUpdate:modelValue": t[0] || (t[0] = (n) => e.selectedLanguage = n),
    options: e.languages,
    width: e.width,
    disableMessages: e.disableMessages,
    validateOn: e.validateOn
  }, null, 8, ["id", "modelValue", "options", "width", "disableMessages", "validateOn"]);
}
const b = /* @__PURE__ */ r(d, [["render", p]]);
export {
  b as LanguageSelectComp
};
//# sourceMappingURL=LanguageSelectComp.js.map
